import { render, staticRenderFns } from "./JobOrientation.vue?vue&type=template&id=04d16dd6"
import script from "./JobOrientation.vue?vue&type=script&lang=js"
export * from "./JobOrientation.vue?vue&type=script&lang=js"
import style0 from "./JobOrientation.vue?vue&type=style&index=0&id=04d16dd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports